import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../material.module';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MY_DATE_FORMATS } from './utils/custom-date-format';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter, MomentDateModule } from '@angular/material-moment-adapter';
import { MatDatepickerModule } from '@angular/material/datepicker'
import { AgmCoreModule } from '@agm/core';
import { NgxMatDatetimePickerModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';
import { ChartsModule } from 'ng2-charts';
import { MatTableFilterModule } from 'mat-table-filter';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { ChargerLogSharedDialogComponent } from './components/charger-log-shared-dialog/charger-log-shared-dialog.component';
import {ChangeConfigurationSharedDialogComponent} from './components/change-configuration-dialog/change-configuration-shared-dialog.component'
import { MapDialogComponent } from './components/map-dialog/map-dialog.component';
import { FuseSharedModule } from '@fuse/shared.module';
import {NgxJsonViewerComponent} from 'app/shared/components/ngx-json-viewer/ngx-json-viewer.component';
const THIRD_MODULES = [
  MaterialModule,
  MomentDateModule,
  ChartsModule,
  MatTableFilterModule
];
const COMPONENTS = [NgxJsonViewerComponent];
const COMPONENTS_DYNAMIC = [ChargerLogSharedDialogComponent,MapDialogComponent,ChangeConfigurationSharedDialogComponent];
const DIRECTIVES = [];
const PIPES = [];


@NgModule({
  declarations: [...COMPONENTS, ...COMPONENTS_DYNAMIC, ...DIRECTIVES, ...PIPES,],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    NgxMaterialTimepickerModule,
    ...THIRD_MODULES,
    FuseSharedModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyA6MzAQocq5JW4YFAXerO1NQfeaZIc-0TY',
    })
  ],
  
  exports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    NgxMaterialTimepickerModule,
    ...THIRD_MODULES,
    ...COMPONENTS,
    ...DIRECTIVES,
    ...PIPES,
  ],
  entryComponents: COMPONENTS_DYNAMIC,
  providers:[
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },

  ]
})
export class SharedModule {}
